import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Img1 from '../../assets/img/payoff/travelNow.png';
import Img2 from '../../assets/img/payoff/payLess.png';
import Img3 from '../../assets/img/payoff/goGreen.png';
import { useTranslation } from 'react-i18next';

const items = [
  { id: 1, frontImage: Img1, key: 'travelNow' },
  { id: 2, frontImage: Img2, key: 'payLess' },
  { id: 3, frontImage: Img3, key: 'goGreen' }
];

const PayOff = () => {
  const { t } = useTranslation();

  return (
    <div className="w-full flex flex-col items-center py-16">
      <div
        className="
          w-full lg:w-3/4  
          flex 
          flex-nowrap
          gap-4 
          overflow-x-auto 
          scrollbar-none 
          lg:grid lg:grid-cols-3 lg:gap-8 lg:overflow-hidden
        "
      >
        {items.map((item) => (
          <FlipCard
            key={item.id}
            frontImage={item.frontImage}
            frontTitle={t(`payoff.cards.${item.key}.frontTitle`)}
            backTitle={t(`payoff.cards.${item.key}.backTitle`)}
            backDescription={t(`payoff.cards.${item.key}.backDescription`)}
          />
        ))}
      </div>
    </div>
  );
};

const FlipCard = ({ frontImage, frontTitle, backTitle, backDescription }) => {
  const [flipped, setFlipped] = useState(false);
  const [shouldShake, setShouldShake] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldShake(true);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <motion.div
      className="
        min-w-[300px]
        md:w-full
        h-[400px] lg:h-[500px]
        relative
        cursor-pointer
        perspective
      "
      onClick={() => setFlipped(!flipped)}
      animate={shouldShake ? { rotateZ: [0, 0, 0, 0, 0, 0] } : {}}
      transition={shouldShake ? { duration: 0.5 } : {}}
      onAnimationComplete={() => setShouldShake(false)}
    >
      <motion.div
        className="relative w-full h-full"
        style={{ transformStyle: 'preserve-3d' }}
        animate={{ rotateY: flipped ? 180 : 0 }}
        transition={{ duration: 0.6 }}
      >
        {/* Fronte */}
        <div
          className="
            absolute 
            w-full 
            h-full 
            rounded-lg 
            overflow-hidden 
          "
          style={{ backfaceVisibility: 'hidden' }}
        >
          <img
            src={frontImage}
            alt="Card front"
            className="w-full h-full object-cover"
          />
          <div
            className="
              absolute 
              bottom-2 
              left-0 
              w-full 
              text-white 
              text-center 
              py-2
            "
          >
            <h3 className="text-3xl uppercase font-heading font-bold italic">{frontTitle}</h3>
          </div>
        </div>

        {/* Retro */}
        <div
          className="
            absolute 
            w-full 
            h-full 
            bg-claudy-blue 
            text-burnt-coffee 
            flex 
            flex-col
            items-center 
            justify-center 
            text-center 
            px-10 
            py-4
            rounded-xl 
          "
          style={{
            transform: 'rotateY(180deg)',
            backfaceVisibility: 'hidden'
          }}
        >
          {/* Descrizione con supporto per i tag HTML */}
          <p
            className="text-base"
            dangerouslySetInnerHTML={{ __html: backDescription }}
          ></p>
          <h3 className="text-3xl absolute bottom-2 font-semibold uppercase font-heading italic mb-2">
            {backTitle}
          </h3>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default PayOff;
